import { render, staticRenderFns } from "./DatesSettings.vue?vue&type=template&id=09b8e546&"
import script from "./DatesSettings.vue?vue&type=script&lang=js&"
export * from "./DatesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports